import React from 'react';
export function Footer() {
  return <footer className="bg-brown-900 text-cream-200/40 py-12 border-t border-white/5" data-id="element-76">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-77">
        <p className="font-serif text-lg text-cream-100" data-id="element-78">
          El Diccionario del Cabello
        </p>
        <p className="text-sm" data-id="element-79">
          © {new Date().getFullYear()} Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}